var _path, _circle, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H36C39.3137 0 42 2.68629 42 6V36C42 39.3137 39.3137 42 36 42H6C2.68629 42 0 39.3137 0 36V6Z",
    fill: "#FF9F43",
    fillOpacity: 0.16
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0001,
    cy: 15.5833,
    r: 4.33333,
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 30.75V28.5833C14.5 26.1901 16.4401 24.25 18.8333 24.25H19.9167",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.8751,
    cy: 26.9583,
    rx: 2.70833,
    ry: 2.70833,
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0417 29.125L30.7501 31.8333",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingUser);
export default __webpack_public_path__ + "static/media/pending-user.6024b84fc6cea535414589a4f43f9bfe.svg";
export { ForwardRef as ReactComponent };